/**
 * This module provides all the needed internal & external
 * hosts used during the runtime of this application
 */

/**
 * Milestones RE
 */

/**
 * Return the RE host without trailing slash
 * @return {string}
 */
export const reHost = () => {
    return `${window.env.MILESTONES_RE_HOST}`.replace(/\/$/, '');
};

/**
 * Return the RE MANAGER host without trailing slash
 * @return {string}
 */
export const reManagerHost = () => {
    return `${window.env.MILESTONES_RE_MANAGER_HOST}`.replace(/\/$/, '');
};


/**
 * @returns {string}
 */
export const myProjectsUrl = (queryParams = {}) => {
    const url = new URL(
        `${reHost()}/my-hubs`
    );

    for (let [key, value] of Object.entries(queryParams)) {
        assertMissing(value);
        url.searchParams.append(key, value);

    }

    url.searchParams.append('source', 'landing-page');

    return url.href;
};

/**
 * @param projectUuid
 * @returns {string}
 */
export const myProjectUrl = (projectUuid) => {
    assertMissing(projectUuid);

    const url = new URL(
        `${reHost()}/project`
    );

    if (projectUuid) {
        url.searchParams.append('projectUuid', projectUuid);
    }

    return url.href;
};


/**
 * @param queryParams
 * @returns {string}
 */
export const newProjectUrl = (queryParams = {}) => {
    const url = new URL(`${reHost()}/project/new`);

    url.searchParams.append('source', 'landing-page');

    for (let [key, value] of Object.entries(queryParams)) {
        assertMissing(value);
        url.searchParams.append(key, value);

    }

    return url.href;
};

/**
 * @param href
 * @param newWindow
 * @returns {Window}
 */
export const redirectTo = (href, newWindow = false) => {
    if (newWindow) {
        return window.open(href, '_blank');
    }

    window.location.href = href;
};


/**
 * @return {string}
 */
export const jotFormUrl = (formId, queryParams) => {
    assertMissing(formId);
    const url = new URL(`${window.env.JOTFORM_URL}/${formId}`);
    for (let [key, value] of Object.entries(queryParams)) {
        assertMissing(value);
        url.searchParams.append(key, value);
    }

    return url.href;
};

/**
 * @param item
 */
const assertMissing = (item) => {
    if (typeof item === 'undefined' || item === null) {
        throw new Error('Missing parameter');
    }
};

/**
 * @returns {string}
 */
export const profileSettingsUrl = (queryParams = {}) => {
    const url = new URL(
        `${reManagerHost()}/profile-settings`
    );

    for (let [key, value] of Object.entries(queryParams)) {
        assertMissing(value);
        url.searchParams.append(key, value);

    }

    return url.href;
};


